import { FC } from "react";

import { ColisResource, DesserteResource } from "types/transport.types";
import DesserteInformationGenerale from "./DesserteInformationGenerale";
import DesserteFacturation from "./DesserteFacturation";
import MainCard from "components/MainCard";
import { ListDesserteColis } from "./ListDesserteColis";
import { DesserteSignatures } from "./DesserteSignatures";
import { DesserteIncident } from "./DesserteIncident";
import {
  ViewIcons,
  ViewItem2 as ViewItem,
  ViewList,
  ViewListItem,
} from "pages/common";
import { Collapse } from "components";
import { CODE_REFERENTIEL } from "types";
import { useUser } from "hooks";
import { ListEventHistorique } from "components/historique";
import { Button, Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { LINKS } from "utils/constant";

type DetailDesserteProps = {
  desserte: DesserteResource;
  updateColis?: (colis: ColisResource) => void;
};

const DetailDesserte: FC<DetailDesserteProps> = ({ desserte, updateColis }) => {
  const { canReadOrWrite } = useUser();
  const canReadFactures = canReadOrWrite("factures");
  const nav = useNavigate();

  return (
    <>
      <DesserteInformationGenerale desserte={desserte} />
      {canReadFactures && <DesserteFacturation desserte={desserte} />}
      <MainCard sx={{ marginBottom: 3 }}>
        <Collapse
          title="Colis"
          subtitle="Liste des colis pris en charge"
          leftIcon={ViewIcons.colis}
        >
          {desserte.withCollecte && (
            <ViewList sx={{ marginBottom: 2 }}>
              <ViewListItem>
                <Grid item xs={12} md={3}>
                  <ViewItem label="Numéro de la collecte">
                    {desserte?.collecte?.numero}
                    <Button
                      size="small"
                      onClick={() => {
                        nav(LINKS.collectes.view(desserte?.collecte?.id!));
                      }}
                    >
                      Consulter
                    </Button>
                  </ViewItem>
                </Grid>
              </ViewListItem>
            </ViewList>
          )}

          <ListDesserteColis
            colis={desserte.colis}
            updateColis={updateColis}
            canEdit={desserte.etatDesserte?.id !== CODE_REFERENTIEL.LIVRE}
          />
        </Collapse>
      </MainCard>
      <MainCard sx={{ marginBottom: 3 }}>
        <DesserteSignatures signatures={desserte.signatures} />
      </MainCard>
      <MainCard sx={{ marginBottom: 3 }}>
        <DesserteIncident desserteId={desserte.id} />
      </MainCard>
      <ListEventHistorique events={desserte.events} />
    </>
  );
};

export default DetailDesserte;
